import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';
import global from '../../../common/utility/global';



const INICIO = 1;
const PROCESO = 2;
const TERMINADO = 3;
const ANULADO = 4;

export default function ResultList(props) {

    const renderColor = (row) => {
        if (row.idProyectoEstado === INICIO)
            return 'blue';
        if (row.idProyectoEstado === PROCESO)
            return 'green';
        if (row.idProyectoEstado === TERMINADO)
            return 'orange';
        if (row.idProyectoEstado === ANULADO)
            return 'red';
    };
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title={"Editar"}>
                                <Button
                                    disabled={(row.idProyectoEstado == TERMINADO || row.idProyectoEstado == ANULADO) ? true : false}
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title={"En Proceso"}>
                                <Button
                                    type={"success"}
                                    icon={"check"}
                                    disabled={(row.idProyectoEstado == INICIO) ? false : true}
                                    size={"small"}
                                    onClick={() => props.onEstadoActive(row, PROCESO)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title={"Terminar"}>
                                <Button
                                    type={"primary"}
                                    icon={"issues-close"}
                                    disabled={(row.idProyectoEstado == PROCESO) ? false : true}
                                    size={"small"}
                                    onClick={() => props.onEstadoActive(row, TERMINADO)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={"Anular"}>
                                <Button
                                    type={"danger"}
                                    icon={"close"}
                                    disabled={(row.idProyectoEstado == TERMINADO || row.idProyectoEstado == ANULADO) ? true : false}
                                    size={"small"}
                                    onClick={() => props.onDeleteActive(row)}
                                />
                            </Tooltip>

                        </div>
                    )
                },
                {
                    title: 'Nombre',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true
                },
                {
                    title: 'Codigo Proyecto',
                    dataIndex: 'numero',
                    key: 'numero',
                    sorter: true
                },
                {
                    title: 'Fecha Inicio',
                    dataIndex: 'fechaInicioStr',
                    key: 'fechaInicioStr',
                    sorter: true
                },
                {
                    title: 'Fecha Fin',
                    dataIndex: 'fechaFinStr',
                    key: 'fechaFinStr',
                    sorter: true
                },
                {
                    title: 'Costo Proyecto',
                    dataIndex: 'costoUnitario',
                    key: 'costoUnitario',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(2))}</span>
                    )
                },
                {
                    title: 'Estado',
                    dataIndex: 'estado',
                    key: 'estado',
                    align: 'center',
                    width: "90px",
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}